// frontend/src/pages/auth/LoginPage.js (نسخه نهایی و کامل)

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaUserShield, FaLock, FaSignInAlt } from 'react-icons/fa';
import { jwtDecode } from 'jwt-decode';
import { API_BASE_URL } from '../../modules/api';
import '../../assets/styles/global.css';

const AuthBranding = () => (
    <div className="auth-branding-panel">
        <div className="branding-content">
            <h1 className="branding-logo">سُهات</h1>
            <p className="branding-tagline">سامانه هوشمند یادگیری و ارزیابی ترکیبی</p>
            <img 
                src="/undraw_education_h8vr.svg"
                alt="آموزش هوشمند" 
                className="branding-illustration"
            />
            <p className="branding-footer">
                تحولی نو در آموزش دیجیتال ایران
            </p>
        </div>
    </div>
);

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            const response = await axios.post(`${API_BASE_URL}/auth/login/`, { username, password });
            const { access, refresh } = response.data;

            localStorage.setItem('accessToken', access);
            localStorage.setItem('refreshToken', refresh);

            const decodedToken = jwtDecode(access);
            const { role, first_name, last_name, username: tokenUsername, organization_id, organization_name } = decodedToken;

            const userFullName = (first_name || last_name) ? `${first_name} ${last_name}`.trim() : tokenUsername;

            localStorage.setItem('userRole', role);
            localStorage.setItem('userName', tokenUsername);
            localStorage.setItem('userFullName', userFullName);
            localStorage.setItem('userOrganizationId', organization_id); 
            localStorage.setItem('userOrganizationName', organization_name);

            switch (role) {
                case 'Teacher':
                    navigate('/teacher/dashboard');
                    break;
                case 'Student':
                    navigate('/student/dashboard');
                    break;
                case 'SchoolAdmin':
                case 'RegionAdmin':
                case 'DistrictAdmin':
                case 'CityAdmin':
                case 'ProvinceAdmin':
                case 'NationalAdmin':
                    navigate('/admin/dashboard');
                    break;
                default:
                    navigate('/');
                    break;
            }

        } catch (err) {
            setError('نام کاربری یا رمز عبور اشتباه است.');
            console.error("Login failed:", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page-container">
            <AuthBranding />
            <div className="auth-form-panel">
                <div className="form-container-card">
                    <h2 className="form-title">ورود به پنل کاربری</h2>
                    <p className="form-subtitle">برای ورود، اطلاعات حساب کاربری خود را وارد نمایید.</p>

                    <form onSubmit={handleSubmit} className="auth-form">
                        <div className="input-group">
                            <FaUserShield className="input-icon" />
                            <input 
                                type="text" 
                                value={username} 
                                onChange={(e) => setUsername(e.target.value)} 
                                placeholder="کد ملی یا نام کاربری" 
                                required 
                                disabled={isLoading}
                                autoComplete="username"
                            />
                        </div>

                        <div className="input-group">
                            <FaLock className="input-icon" />
                            <input 
                                type="password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                placeholder="رمز عبور" 
                                required 
                                disabled={isLoading}
                                autoComplete="current-password"
                            />
                        </div>
                        
                        {error && <p className="error-message">{error}</p>}

                        <div className="form-options">
                            <label className="checkbox-container">
                                <input type="checkbox" />
                                مرا به خاطر بسپار
                            </label>
                            <a href="#" className="forgot-password-link">فراموشی رمز عبور</a>
                        </div>
                        
                        <button type="submit" disabled={isLoading} className="button-primary auth-button">
                            <FaSignInAlt />
                            {isLoading ? 'در حال بررسی...' : 'ورود به سامانه'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;